
import { addActivities, displayActivitiesHeader, initializeRouteMap } from '../functions.js';

jQuery(function($) {
    if ($('.single-gemeente').length == 0) {
        return;
    }

    let gemeenteID = $('.site-content.single-gemeente').data('id');



    $.get("/wp-json/wemake/v1/get-token", function (response) {
        if (response.token) {
            getActivities(response.token); // Fetch activities
            getMunicipalData(response.token); // Fetch municipal data
            get10kmActivities(response.token);
            getRoutes(response.token);
        }
        else{
            console.log('Error getting token');
        }
    });



    // Fetch routes
    function getRoutes(token) {
        $.ajax({
            url: 'https://cockpit.qr-fit.nl/ext-website/v1/municipalities/' + gemeenteID + '/routes?per_page=20',
            method: "GET",
            headers: { "Authorization": "Bearer " + token },
            success: function (response) {
                if (response.data && response.data.length > 0) {
                    $(".routes").removeClass('hide');
                }
                $('.beweegroutes__count').text(response.data.length);
                generateRoutesHTML(response.data);
                console.log(response);

            },
            error: function (xhr) {
                console.error("Failed to fetch routes: " + xhr.responseText);
            }
        });
    }


    // Fetch gemeente data
    function getMunicipalData(token) {
        $.ajax({
            url: 'https://cockpit.qr-fit.nl/ext-website/v1/municipalities/' + gemeenteID + '/stats',
            method: "GET",
            headers: { "Authorization": "Bearer " + token },
            success: function (response) {
                $('.beweegroutes__count').text(response.implemented_routes_count);
                $('.activiteiten__count').text(response.open_activities_count);

            },
            error: function (xhr) {
                console.error("Failed to fetch stats: " + xhr.responseText);
            }
        });
    }

    function getActivities(token) {
        $.ajax({
            url: 'https://cockpit.qr-fit.nl/ext-website/v1/municipalities/' + gemeenteID + '/activities',
            method: "GET",
            headers: { "Authorization": "Bearer " + token },
            success: function (response) {
                // Remove duplicate activities based on ID
                const uniqueActivitiesMap = new Map();
                response.data.forEach(activity => {
                    if (!uniqueActivitiesMap.has(activity.id)) {
                        uniqueActivitiesMap.set(activity.id, activity);
                    }
                });

                const uniqueActivities = Array.from(uniqueActivitiesMap.values());

                // Replace the original data with the unique one
                response.data = uniqueActivities;

                displayActivitiesHeader(response);      
                addActivities(response);
                console.log('activities', response);

                $('.activiteiten .meer-activiteiten').on('click', displayMoreActivities);
            },
            error: function (xhr) {
                console.error("Failed to fetch activities: " + xhr.responseText);
            }
        });
    }

    function get10kmActivities(token) {
        $.ajax({
            url: 'https://cockpit.qr-fit.nl/ext-website/v1/municipalities/' + gemeenteID + '/activities-10km',
            method: "GET",
            headers: { "Authorization": "Bearer " + token },
            success: function (response) {
                if (response.data.length > 0){
                    $('.activiteiten10km').removeClass('hide');
                }
                displayActivitiesHeader(response, '.activiteiten10km');      
                addActivities(response, '.activiteiten10km');
                console.log('activities-10km', response);
                $('.activiteiten10km .meer-activiteiten').on('click', displayMoreActivities);

            },
            error: function (xhr) {
                console.error("Failed to fetch activities: " + xhr.responseText);
            }
        });
    }

    console.log('11/07');    

    function displayMoreActivities(event) {
        const $btn = $(event.currentTarget);
        const page = $btn.data('page');
        const container = $btn.closest('.activiteiten, .activiteiten10km');
        const is10km = container.hasClass('activiteiten10km');
        const apiPath = is10km ? 'activities-10km' : 'activities';
        const resultSelector = is10km ? '.activiteiten10km .activiteiten__results-wrap' : '.activiteiten .activiteiten__results-wrap';
    
        $btn.remove();
        $(resultSelector).addClass('loading');
    
        $.get("/wp-json/wemake/v1/get-token", function (response) {
            if (response.token) {
                $.ajax({
                    url: `https://cockpit.qr-fit.nl/ext-website/v1/municipalities/${gemeenteID}/${apiPath}?page=${page}`,
                    method: "GET",
                    headers: { "Authorization": "Bearer " + response.token },
                    success: function (response) {
                        addActivities(response, is10km ? '.activiteiten10km' : undefined);
                        container.find('.meer-activiteiten').on('click', displayMoreActivities);
                        console.log('extra activities', response);
                    },
                    error: function (xhr) {
                        console.error(`Failed to fetch ${apiPath}: ` + xhr.responseText);
                    }
                });
            } else {
                console.log('Error getting token');
            }
        });
    }
    

    // Generate routes HTML
    function generateRoutesHTML(routes) {
        let routeNavHTML = "";
        let routeContentHTML = "";

        routes.forEach((route, index) => {
            let isActive = index === 0 ? "active" : "";

            // Route Nav list
            routeNavHTML += `
                <div class="route__select card--small light d-f gap-8 f-a-c cursor ${isActive}" data-index="${index}">
                    <img src="${route.type == 'virtual' ? '/wp-content/uploads/2025/02/QR-FIT-bench-icon-1.png' : '/wp-content/uploads/2025/02/Exercise-point-Physical-trail-1.png'}" class="br-8" width="50" height="70" alt="Route afbeelding">
                    <span class="w-500">${route.name}</span>
                </div>`;

            // Route Content
            routeContentHTML += `
            <div class="w-100">
                <div class="hidden-small-reverse route__select card--small light d-f gap-8 f-a-c cursor ${isActive}" data-index="${index}">
                    <img src="${route.type == 'virtual' ? '/wp-content/uploads/2025/02/QR-FIT-bench-icon-1.png' : '/wp-content/uploads/2025/02/Exercise-point-Physical-trail-1.png'}" class="br-8" width="50" height="70" alt="Route afbeelding">
                    <span class="w-500">${route.name}</span>
                </div>
                
                <div class="route__card flex-grow card light br-16 d-f gap-32 ${isActive}" data-index=${index}>
                    <div class="flex-50 flex-100-s d-f fd-c gap-24">
                        <div class="d-f fd-c gap-8 route__info">
                            <span class="t-c-green">${route.type == 'virtual' ? 'Virtuele route' : 'Fysieke route'}</span>
                            <h3>${route.name}</h3>
                            <div class="d-f gap-8">
                                <span class="route__partner t-13">Afnemer: <strong>${route.customer_name}</strong></span> 
                            </div>
                            <div class="d-f gap-8">
                                <img width="20" height="20" src="/wp-content/uploads/2024/10/Afstand-icoontje-1.svg" alt="">
                                <strong>Lengte</strong>
                                <div class="t-c-s">${route.length_in_km} kilometer</div>
                            </div>
                            <div class="d-f gap-8">
                                <img width="20" height="20" src="/wp-content/uploads/2024/10/Icon-fill-6.svg" alt="">
                                <strong>Gemiddelde duur</strong>
                                <div class="t-c-s">${route.estimated_duration_in_minutes} min</div>
                            </div>
                            <div class="format-desc">
                                ${route.long_description}
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow p-r">
                        <div class="route__map br-16" data-index="${index}"></div>
                    </div>
                </div>
            </div>`;

            fetchCoachByRoute(route.name, index);
        });

        // Insert into HTML
        $(".routes .routes__nav").html(routeNavHTML);
        $(".routes .routes__content").html(routeContentHTML);

        // Store map instances
        let routeMaps = {};

        // Initialize maps for each route
        $(".route__map").each(function () {
            let index = $(this).data("index");
            let selectedRoute = routes[index];

            if (selectedRoute.exercise_points && selectedRoute.waypoints) {
                let mapInstance = initializeRouteMap(this, selectedRoute.exercise_points, selectedRoute.waypoints);
                routeMaps[index] = mapInstance; // Store map reference
            }
        });

        // Route selection click event
        $(".route__select").on("click", function () {
            let index = $(this).data("index");
            let selectedRoute = routes[index];

            if (routeMaps[index]) {
                let newCenter;
                
                // Center wordt het midden van alle exercise points
                if (selectedRoute.exercise_points.length > 0) {
                    // Calculate the average latitude and longitude
                    let totalLat = 0, totalLng = 0;
                    selectedRoute.exercise_points.forEach(point => {
                        totalLat += point.lat;
                        totalLng += point.lng;
                    });
            
                    newCenter = {
                        lat: totalLat / selectedRoute.exercise_points.length,
                        lng: totalLng / selectedRoute.exercise_points.length
                    };
                } else if (selectedRoute.waypoints.length > 0) {
                    // Fallback to the first waypoint if no exercise points exist
                    newCenter = { lat: selectedRoute.waypoints[0].lat, lng: selectedRoute.waypoints[0].lng };
                }
            
                routeMaps[index].setCenter(newCenter);
            }
            

            // Set active class for the selected route
            $(".route__select, .route__card").removeClass("active");
            $(`.route__select[data-index="${index}"]`).addClass("active");
            $(`.route__card:eq(${index})`).addClass("active");
        });

    }


    function fetchCoachByRoute(routeName, index) {
        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'get_coach_by_route_name',
                name: routeName,
            },
            success: function (response) {
                // Ensure response is successful
                if (response.success && response.data.found) {
                    $('.route__card[data-index=' + index + '] .route__info').append(`
                        <div class="d-f fd-c gap-8">
                            <a href="mailto:${response.data.data['email']}" class="d-f fw-n f-a-c gap-16">
                                <img width="60" height="80" src="${response.data.data['foto']}" class="route__coach-foto br-circle cover">
                                <div class="d-f fd-c">
                                    <strong>${response.data.title}</strong>
                                    <span class="t-c-s">Coach op deze route</span>
                                </div>
                            </a>
                            <a href="mailto: ${response.data.data['email']}" class="arrow t-c-green">Contact opnemen</a>
                        </div>
                        `);
                }
            },
            error: function (xhr, status, error) {
                console.error('Error:', error);
            }
        });
    }
    
    
    
    
});







